import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import InlineValue from '../InlineValue';
import { projectTimezoneIdSelector } from '../../../reducers/projects';
import { timezonesSelector, getTimezoneOffset } from '../../../reducers/timezones';
import { formatDate } from '../../../helpers/timezone';
// import { timeZoneHelperSelector } from '../TimeZone/TimeZoneHelpers';

const BonusField = ({ label, value }) =>
  <div>
    <span className="badge badge-info mr-1">{label}</span>
    <small>{value}</small>
  </div>;

BonusField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

const getBonusField = (value, timezoneOffset) => {
  let startDate;
  let finishDate;
  switch (value.get('status')) {
    case 'Blocked':
      startDate = value.get('startDate', '');
      startDate = formatDate(timezoneOffset, startDate, 'L');
      // startDate = timeZoneHelper.formatDate(startDate, 'L');
      return (
        <div>
          <BonusField label="Reason" value={value.get('reason', '')} />
          <BonusField
            label="Start Date"
            value={startDate}
          />
        </div>
      );
    case 'Not Started':
      startDate = value.get('startDate', '');
      if (!startDate) return null;
      startDate = formatDate(timezoneOffset, startDate, 'L');
      // startDate = timeZoneHelper.formatDate(startDate, 'L');
      return (
        <BonusField
          label="Start Date"
          value={startDate}
        />
      );
    case 'In Progress':
      startDate = value.get('startDate', '');
      startDate = formatDate(timezoneOffset, startDate, 'L');
      // startDate = timeZoneHelper.formatDate(startDate, 'L');
      return (
        <BonusField
          label="Start Date"
          value={startDate}
        />
      );
    case 'Finished':
      startDate = value.get('startDate', '');
      startDate = formatDate(timezoneOffset, startDate, 'L');
      // startDate = timeZoneHelper.formatDate(startDate, 'L');
      finishDate = value.get('finishDate', '');
      finishDate = formatDate(timezoneOffset, finishDate, 'L');
      // finishDate = timeZoneHelper.formatDate(finishDate, 'L');
      return (
        <div>
          <BonusField
            label="Start Date"
            value={startDate}
          />
          <BonusField
            label="Finish Date"
            value={finishDate}
          />
        </div>
      );
    default:
      return null;
  }
};

const DisplaySelector = createSelector(
  [timezonesSelector, projectTimezoneIdSelector],
  (timezones, projectTimezoneId) =>  ({
    timezoneOffset: getTimezoneOffset(timezones, projectTimezoneId),
  }),
);
// const DisplaySelector = createSelector(
//   [timeZoneHelperSelector],
//   (timeZoneHelper) => ({ timeZoneHelper }),
// );
@connect(DisplaySelector)
export default class TaskStatusValueDisplay extends PureComponent {
  static propTypes = {
    // timeZoneHelper: PropTypes.object,
    timezoneOffset: PropTypes.number,
    toggleEditor: PropTypes.func,
    userMode: PropTypes.string,
    value: PropTypes.object,
  };

  render() {
    const { timezoneOffset, toggleEditor, userMode, value } = this.props;

    const clickToEdit = (userMode !== 'reader')
      ? <span className="clickToEdit">Click to edit</span>
      : null;
    if (!value || !value.size || !value.has('status')) {
      return (
        <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
          {clickToEdit}
        </InlineValue>
      );
    }

    return (
      <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
        <div className="d-inline-block">
          {value.get('status')}
          {getBonusField(value, timezoneOffset)}
        </div>
      </InlineValue>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/types/TaskStatus/TaskStatusValueDisplay.js